<template>
  <ContentSection class="relative">
    <Container indent="wide">
      <div class="justify-between gap-10 lg:flex">
        <h2
          v-if="data.heading"
          class="default-component-title"
          :class="data.link ? 'mb-3 xl:mb-8' : 'mb-8 sm:mb-10'"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <AppLink
          v-if="data.link && data.link_text"
          class="mb-7 sm:text-md xl:mb-0"
          :target="data.target?.value"
          :to="data.link"
        >
          {{ data.link_text }}
        </AppLink>
      </div>
    </Container>
    <!-- COURSES -->
    <AnimatedContainer>
      <ul class="hidden grid-cols-4 gap-6 px-12 2xl:grid">
        <li v-for="course in courses" :key="course.id" class="slide-in-left">
          <CourseCard :data="course" />
        </li>
      </ul>
    </AnimatedContainer>

    <!-- COURSES MOBILE -->
    <div class="2xl:hidden">
      <Swiper
        :slides-per-view="1.5"
        :space-between="12"
        :slides-offset-before="24"
        :slides-offset-after="24"
        :breakpoints="breakpoints"
      >
        <SwiperSlide v-for="course in courses" :key="course.id">
          <CourseCard :data="course" />
        </SwiperSlide>
      </Swiper>
    </div>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, default: () => ({}) },
})

const pageId = inject('pageId', null)

const { locale } = useI18n()
const fetchedCourses = ref(null)

const breakpoints = {
  640: {
    // sm
    slidesOffsetBefore: 40,
    slidesOffsetAfter: 40,
    slidesPerView: 1.5,
  },
  768: {
    // md
    slidesPerView: 2.5,
    spaceBetween: 20,
  },
  1024: {
    // lg
    slidesPerView: 3.5,
  },
}

// FUNCTIONS
async function fetchCourses() {
  let payload = await useAsyncGql({
    operation: 'Courses',
    variables: {
      sort: 'title asc',
      limit: 4,
      filter: {
        site: locale.value,
        id: { not: pageId },
        section: switchContainsOrIn(props.data?.restricted_sections),
      },
    },
  })

  payload = payload.data.value?.entries

  if (!payload) {
    console.error('CoursesTeaser: Courses could not be fetched')
    return
  }

  fetchedCourses.value = payload.data
}

// COMPUTED
const courses = computed(() => {
  if (props.data.selection.value === 'automatic') {
    return fetchedCourses.value || []
  }

  return props.data.courses || []
})

// WATCHERS
watch(
  () => props.data,
  async (newValue) => {
    if (newValue.selection?.value === 'automatic') {
      await fetchCourses()
    }
  },
  { deep: true }
)

// INITIAL
if (props.data.selection.value === 'automatic') {
  await fetchCourses()
}
</script>
